export var BodySizes;
(function (BodySizes) {
    BodySizes["body_1"] = "body_1";
    BodySizes["body_2"] = "body_2";
    BodySizes["body_caption"] = "body_caption";
})(BodySizes || (BodySizes = {}));
export var BodyWeights;
(function (BodyWeights) {
    BodyWeights["regular"] = "regular";
    BodyWeights["bold"] = "bold";
})(BodyWeights || (BodyWeights = {}));
export var BodyVariants;
(function (BodyVariants) {
    BodyVariants["base"] = "base";
    BodyVariants["variant"] = "variant";
})(BodyVariants || (BodyVariants = {}));
//# sourceMappingURL=constants.js.map